import { useEffect, useState } from 'react';

const subscribers =
  new Set();

/*
 * Mobile Student App refreshes are allowed only at safe
 * boundaries.
 *
 * While a student is actively working in a form/tool/detail
 * screen, refresh requests are remembered rather than emitted.
 *
 * Multiple requests while blocked collapse into ONE pending
 * refresh.
 */
let refreshSafe = true;
let refreshPending = false;


function emitRefresh() {
  subscribers.forEach(listener => {
    try {
      listener();
    } catch (error) {
      console.error(
        'Student data refresh listener failed:',
        error
      );
    }
  });
}


export function requestStudentDataRefresh() {
  if (!refreshSafe) {
    refreshPending = true;

    return false;
  }

  refreshPending = false;

  emitRefresh();

  return true;
}


export function setStudentDataRefreshSafe(
  isSafe
) {
  refreshSafe =
    isSafe === true;

  /*
   * As soon as the student reaches a safe screen,
   * consume any refresh that accumulated while they
   * were working.
   */
  if (
    refreshSafe &&
    refreshPending
  ) {
    refreshPending = false;

    emitRefresh();

    return true;
  }

  return false;
}


/*
 * Used when the Mobile Student App itself unmounts.
 *
 * Do NOT emit a pending refresh during logout/unmount.
 */
export function resetStudentDataRefreshGate() {
  refreshSafe = true;
  refreshPending = false;
}


export function useStudentDataRefreshTick() {
  const [tick, setTick] =
    useState(0);

  useEffect(() => {
    const listener = () => {
      setTick(
        value =>
          value + 1
      );
    };

    subscribers.add(
      listener
    );

    return () => {
      subscribers.delete(
        listener
      );
    };
  }, []);

  return tick;
}
